/* DTACHED minimal: cart drawer, quick "Buy now" sizes on cards, home sliders */
(function(){
'use strict';
var CFG=window.dtCartCfg||{},ROOT=CFG.root||'/',CART=CFG.cart||'/cart',CHECKOUT=CFG.checkout||'/checkout';
var doc=document,busy=false,last=null;
function money(c){c=+c||0;var v=c/100;return '$'+(c%100?v.toFixed(2):String(v))}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function api(path,body){
  var o={headers:{'Accept':'application/json'}};
  if(body){o.method='POST';o.headers['Content-Type']='application/json';o.body=JSON.stringify(body)}
  return fetch(ROOT+path,o).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
}
/* ---------- drawer ---------- */
var el=doc.createElement('div');el.className='mc';el.id='mc';el.setAttribute('aria-hidden','true');
el.innerHTML='<div class="mc-bg" data-mc-close></div>'+
  '<aside class="mc-panel" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1">'+
  '<button type="button" class="mc-back" data-mc-close>&larr;&nbsp; Continue shopping</button>'+
  '<h2 class="mc-h">Your cart (<span data-mc-n>0</span>)</h2>'+
  '<p class="mc-msg" data-mc-msg hidden></p>'+
  '<div class="mc-items" data-mc-items></div>'+
  '<div class="mc-foot" data-mc-foot>'+
    '<div class="mc-sub"><span>Subtotal</span><b data-mc-sub>$0</b></div>'+
    '<p class="mc-note">Shipping, taxes and discounts calculated at checkout.</p>'+
    '<div class="mc-btns"><a class="mc-b" href="'+CART+'">View cart</a><a class="mc-b ink" href="'+CHECKOUT+'">Checkout</a></div>'+
  '</div></aside>';
function mount(){if(!el.parentNode)doc.body.appendChild(el)}
function setCount(n){doc.querySelectorAll('[data-mn-cart]').forEach(function(a){a.textContent='Cart ('+n+')'})}
function render(c){
  last=c;mount();
  el.querySelector('[data-mc-n]').textContent=c.item_count;setCount(c.item_count);
  el.querySelector('[data-mc-sub]').textContent=money(c.total_price);
  el.querySelector('[data-mc-foot]').hidden=!c.item_count;
  var box=el.querySelector('[data-mc-items]');
  if(!c.items.length){box.innerHTML='<p class="mc-empty">Your cart is empty.</p>';return}
  box.innerHTML=c.items.map(function(it){
    var img=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=240':'';
    var opts=(it.options_with_values||[]).filter(function(o){return o.value!=='Default Title'}).map(function(o){return '<span>'+esc(o.name)+': '+esc(o.value)+'</span>'}).join('');
    var props=it.properties?Object.keys(it.properties).filter(function(k){var v=it.properties[k];return k.charAt(0)!=='_'&&v&&typeof v==='string'&&!/^https?:/.test(v)&&!/link/i.test(k)}).slice(0,4).map(function(k){return '<span>'+esc(k)+': '+esc(it.properties[k])+'</span>'}).join(''):'';
    return '<div class="mc-it" data-key="'+esc(it.key)+'">'+
      '<a class="mc-img" href="'+esc(it.url)+'">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+'</a>'+
      '<div class="mc-info"><a class="mc-name" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
      '<div class="mc-opt">'+opts+props+'</div>'+
      '<div class="mc-row"><div class="mc-qty"><button type="button" data-q="-1" aria-label="Less">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="1" aria-label="More">+</button></div>'+
      '<span class="mc-pr">'+money(it.final_line_price)+'</span></div>'+
      '<button type="button" class="mc-rm" data-rm>Remove</button></div></div>';
  }).join('');
}
function msg(t){var m=el.querySelector('[data-mc-msg]');m.textContent=t||'';m.hidden=!t}
function open(){mount();el.classList.add('on');el.setAttribute('aria-hidden','false');doc.documentElement.classList.add('mc-lock');setTimeout(function(){el.querySelector('.mc-panel').focus()},30)}
function close(){el.classList.remove('on');el.setAttribute('aria-hidden','true');doc.documentElement.classList.remove('mc-lock')}
function refresh(){return api('cart.js').then(function(c){render(c);return c})}
function add(id,qty){
  return api('cart/add.js',{items:[{id:+id,quantity:qty||1}]}).then(function(){return refresh()}).then(function(c){msg('');open();return c});
}
function change(key,q){
  if(busy)return;busy=true;el.classList.add('busy');
  api('cart/change.js',{id:key,quantity:q}).then(function(c){render(c);msg('')},function(e){msg((e&&(e.description||e.message))||'Could not update the cart.');return refresh()})
    .then(function(){busy=false;el.classList.remove('busy')});
}
el.addEventListener('click',function(e){
  if(e.target.closest('[data-mc-close]')){e.preventDefault();close();return}
  var row=e.target.closest('.mc-it');if(!row)return;var key=row.dataset.key;
  var it=(last&&last.items||[]).find(function(i){return i.key===key});if(!it)return;
  var q=e.target.closest('[data-q]');if(q){change(key,Math.max(0,it.quantity+(+q.dataset.q)));return}
  if(e.target.closest('[data-rm]'))change(key,0);
});
doc.addEventListener('keydown',function(e){if(e.key==='Escape'&&el.classList.contains('on'))close()});
doc.addEventListener('click',function(e){
  var a=e.target.closest('[data-mn-cart]');
  if(a&&!e.metaKey&&!e.ctrlKey){e.preventDefault();refresh().then(open,function(){location.href=CART})}
});
window.dtCart={add:add,open:function(){return refresh().then(open)},close:close,refresh:refresh};

/* ---------- quick "Buy now" on product cards ---------- */
doc.addEventListener('click',function(e){
  var card=e.target.closest('[data-qa]');if(!card)return;
  var openB=e.target.closest('[data-qa-open]'),x=e.target.closest('[data-qa-x]'),v=e.target.closest('[data-qa-v]'),one=e.target.closest('[data-qa-add]');
  var panel=card.querySelector('[data-qa-panel]');
  if(openB){e.preventDefault();doc.querySelectorAll('[data-qa].qa-on').forEach(function(c){if(c!==card){c.classList.remove('qa-on');var p=c.querySelector('[data-qa-panel]');if(p)p.hidden=true}});
    if(panel){var show=panel.hidden;panel.hidden=!show;card.classList.toggle('qa-on',show)}return}
  if(x){e.preventDefault();panel.hidden=true;card.classList.remove('qa-on');return}
  var btn=v||one;if(!btn||btn.disabled)return;
  e.preventDefault();btn.classList.add('wait');
  add(btn.dataset.qaV||btn.dataset.qaAdd,1).then(function(){btn.classList.remove('wait');if(panel){panel.hidden=true;card.classList.remove('qa-on')}},
    function(err){btn.classList.remove('wait');var n=card.querySelector('[data-qa-err]');if(n){n.textContent=(err&&err.description)||'Could not add this size.';n.hidden=false;setTimeout(function(){n.hidden=true},3500)}});
});

/* ---------- home: tabbed horizontal product rows ---------- */
function bar(row){
  var sec=row.closest('[data-rows]');if(!sec)return;var i=sec.querySelector('[data-row-bar]');if(!i)return;
  var w=row.scrollWidth||1,c=row.clientWidth;i.style.width=Math.min(100,c/w*100)+'%';i.style.left=(row.scrollLeft/w*100)+'%';
}
function setupRows(sec){
  var tabs=sec.querySelectorAll('[data-row-tab]'),rows=sec.querySelectorAll('[data-row]'),all=sec.querySelector('[data-row-all]');
  function cur(){return sec.querySelector('[data-row]:not([hidden])')}
  tabs.forEach(function(t,i){t.addEventListener('click',function(e){e.preventDefault();
    tabs.forEach(function(x){x.classList.toggle('on',x===t);x.setAttribute('aria-selected',x===t)});
    rows.forEach(function(r,j){r.hidden=j!==i});if(all)all.href=t.dataset.url;var r=cur();if(r){r.scrollLeft=0;bar(r)}})});
  rows.forEach(function(r){r.addEventListener('scroll',function(){bar(r)},{passive:true})});
  sec.querySelectorAll('[data-row-step]').forEach(function(b){b.addEventListener('click',function(){var r=cur();if(r)r.scrollBy({left:(+b.dataset.rowStep)*r.clientWidth*0.9,behavior:'smooth'})})});
  var r=cur();if(r)bar(r);window.addEventListener('resize',function(){var r=cur();if(r)bar(r)});
}
function init(){doc.querySelectorAll('[data-rows]').forEach(setupRows)}
if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',init);else init();
})();
